var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "mb-4 shadow-sm",
          attrs: { title: "ECommerce Setup / Users" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-md-row justify-content-between align-items-center mb-4",
            },
            [
              _c("div", { staticClass: "mb-2 mb-md-0" }, [
                _c("h4", { staticClass: "mb-0" }, [_vm._v("Manage Setup")]),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v("Configure your e-commerce store settings here."),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "d-flex gap-2" },
                [
                  !_vm.hasAdmin
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function ($event) {
                              _vm.showAddUserModal = true
                            },
                          },
                        },
                        [_vm._v(" Set Up Account ")]
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-primary" },
                      on: { click: _vm.redirectToStore },
                    },
                    [_vm._v(" Visit Store ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-modal",
            {
              attrs: {
                title: "Setup Ecommerce",
                "hide-footer": "",
                centered: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "modal-header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("b-icon", {
                            staticClass: "me-2",
                            attrs: { icon: "gear" },
                          }),
                          _c("h5", { staticClass: "mb-0" }, [
                            _vm._v("Setup Ecommerce"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.showAddUserModal,
                callback: function ($$v) {
                  _vm.showAddUserModal = $$v
                },
                expression: "showAddUserModal",
              },
            },
            [
              _c("validation-observer", {
                ref: "addUser",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.addUser($event)
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: "Email", "label-for": "email" },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Email",
                                    vid: "Email",
                                    rules: "required|email_regex",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "email",
                                                id: "email",
                                                placeholder:
                                                  "Enter your email (e.g., example@domain.com)",
                                              },
                                              model: {
                                                value: _vm.newUser.email,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newUser,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "newUser.email",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Username",
                                  "label-for": "username",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Username",
                                    vid: "Username",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "username",
                                                placeholder: "Enter username",
                                              },
                                              model: {
                                                value: _vm.newUser.username,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newUser,
                                                    "username",
                                                    $$v
                                                  )
                                                },
                                                expression: "newUser.username",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Password",
                                  "label-for": "password",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Password",
                                    vid: "Password",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "password",
                                                id: "password",
                                                placeholder: "Enter password",
                                              },
                                              model: {
                                                value: _vm.newUser.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newUser,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "newUser.password",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Shop Name",
                                  "label-for": "shopName",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Shop Name",
                                    vid: "Shop Name",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "shopName",
                                                placeholder: "Enter shop name",
                                              },
                                              model: {
                                                value: _vm.newUser.shopName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newUser,
                                                    "shopName",
                                                    $$v
                                                  )
                                                },
                                                expression: "newUser.shopName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-end gap-2 mt-4",
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "secondary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showAddUserModal = false
                                      },
                                    },
                                  },
                                  [_vm._v(" Cancel ")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "button",
                                      variant: "primary",
                                    },
                                    on: { click: _vm.addUser },
                                  },
                                  [
                                    _c("b-icon", {
                                      staticClass: "me-2",
                                      attrs: { icon: "check" },
                                    }),
                                    _vm._v(" Submit "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "mb-4", attrs: { title: "ECommerce Users" } },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "perPage" } },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    staticClass: "w-auto",
                    attrs: { id: "perPage", options: _vm.perPageOptions },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("b-table", {
            attrs: {
              items: _vm.userEntries,
              fields: _vm.fields,
              responsive: "sm",
              bordered: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
            },
          }),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mt-3",
            },
            [
              _c("div", [
                _vm._v(
                  "Showing " +
                    _vm._s(_vm.firstItem) +
                    " to " +
                    _vm._s(_vm.lastItem) +
                    " of " +
                    _vm._s(_vm.totalEntries) +
                    " entries"
                ),
              ]),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalEntries,
                  "per-page": _vm.perPage,
                  align: "right",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }